import { Component } from "react";
import PropTypes from "prop-types";
import { NavigationControl as MapBoxNavigationControl } from "mapbox-gl";

class NavigationControl extends Component {
  static contextTypes = { map: PropTypes.object.isRequired };

  componentDidMount() {
    const { map } = this.context;
    map.addControl(new MapBoxNavigationControl());
  }

  render() {
    return null;
  }
}

export default NavigationControl;



// WEBPACK FOOTER //
// ./src/NewRoute/components/NavigationControl.js